import React, { FC, useMemo } from 'react';

import { PLATFORM_APP_ID } from 'src/common/consts/dom-consts';
import {
	DEFAULT_ENVIRONMENT_DISPLAY_NAME,
	DEFAULT_UNIT_ID_DISPLAY_NAME
} from 'src/common/consts/platformConfigConsts';
import { DEFAULT_PERIOD_OPTION } from 'src/common/helpers/DataFilterHelper';
import {
	buildPanelInitialValues,
	mapToPanelDefinitions
} from 'src/common/helpers/FiltersPanelHelper';

import { useWebSdkTestsFilters } from '../../hooks/useWebSdkTestsFilters';
import { FilterSectionV2Props, V2Filters } from '../../types/filter-section-v2';
import { FilterSectionCommon } from '../filter-section/shared/FilterSectionCommon';
import { useFilterApplyHandler } from '../filter-section/shared/useFilterApplyHandler';
import { WebSdkTestsFilterSectionTitleRow } from '../filter-section/shared/WebSdkTestsFilterSectionTitleRow';

export const FilterSectionV2: FC<FilterSectionV2Props> = ({
	isFilterOptionsLoading,
	filterOptions,
	filters,
	showTestPath,
	showRecentTest,
	onShowRecentTestToggle,
	unitIdDisplayName = DEFAULT_UNIT_ID_DISPLAY_NAME,
	environmentDisplayName = DEFAULT_ENVIRONMENT_DISPLAY_NAME,
	onFilterChange
}) => {
	const { handleApply } = useFilterApplyHandler({
		filterOptionsType: 'v2',
		onFilterChange: onFilterChange
			? (flatFilters: V2Filters) => {
					onFilterChange({
						...flatFilters,
						testPeriod: flatFilters.testPeriod ?? [DEFAULT_PERIOD_OPTION]
					});
				}
			: undefined
	});

	const { filterDefinitions, mergedFilterOptions } = useWebSdkTestsFilters({
		allLabels: filterOptions.labels ?? [],
		selectedLabels: filters?.labels ?? [],
		filterOptions,
		unitIdDisplayName,
		environmentDisplayName,
		isV2: true
	});

	const panelDefinitions = useMemo(
		() => mapToPanelDefinitions(filterDefinitions),
		[filterDefinitions]
	);

	const initialValues = useMemo(
		() => buildPanelInitialValues(panelDefinitions, filters),
		[panelDefinitions, filters]
	);

	return (
		<FilterSectionCommon
			isFilterOptionsLoading={isFilterOptionsLoading}
			showTestPath={showTestPath}
			titleRow={
				<WebSdkTestsFilterSectionTitleRow
					showRecentTest={showRecentTest}
					onShowRecentTestToggle={onShowRecentTestToggle}
				/>
			}
			layoutClassName="product-filters-panel-layout"
			providerProps={{
				appElement: PLATFORM_APP_ID,
				onApply: handleApply,
				onReset: handleApply,
				initialValues,
				filterOptions: mergedFilterOptions,
				filterDefinitions: panelDefinitions
			}}
		/>
	);
};
